/* If you edit this file, please remove this header and clean up the resulting eslint errors.
*/
/* eslint-disable
  import/no-commonjs,
  import/no-extraneous-dependencies
*/
import React from 'react';
import BlueButton from 'common/components/buttons/blue';
import createReactClass from 'create-react-class';

const ContentButton = createReactClass({

  getDefaultProps() {
    return {
      buttonColor: 'white',
      buttonTextColor: 'cerulean',
    };
  },

  render() {
    // this
    return (
      <BlueButton
        {...this.props}
        className={`m-signer-mobile-header-button border-1-cerulean ${this.props.className}`}
        buttonText={this.props.children || this.props.buttonText} />
    );
  },

});

module.exports = ContentButton;
